/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./AUOPanel.vue?vue&type=template&id=ddbf0c56&scoped=true&"
import script from "./AUOPanel.vue?vue&type=script&lang=js&"
export * from "./AUOPanel.vue?vue&type=script&lang=js&"
import style0 from "./AUOPanel.vue?vue&type=style&index=0&id=ddbf0c56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddbf0c56",
  null
  
)

export default component.exports